import type { ReactNode } from "react";
import { Empty, Typography } from "antd";

const { Text, Title } = Typography;

interface PreviewShellProps {
  title: string;
  titleAddon?: ReactNode;
  subtitle?: string;
  hasContent: boolean;
  emptyText?: string;
  summaryText?: string;
  children: ReactNode;
}

/**
 * Wrapper for the preview card shown in the right panel of wide configurators.
 * Handles the title, empty state, and bottom summary caption.
 */
export function PreviewShell({
  title,
  titleAddon,
  subtitle,
  hasContent,
  emptyText = "Pick a metric to see a preview",
  summaryText,
  children,
}: PreviewShellProps) {
  return (
    <>
      <div className="awm-preview-card">
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Title level={5} style={{ margin: 0 }}>
            {title}
          </Title>
          {titleAddon}
        </div>
        {subtitle && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {subtitle}
          </Text>
        )}
        <div style={{ flex: 1, marginTop: 12, minHeight: 0, overflow: "auto" }}>
          {hasContent ? (
            children
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={emptyText}
            />
          )}
        </div>
      </div>
      {summaryText && (
        <Text
          type="secondary"
          style={{ display: "block", textAlign: "center", marginTop: 8, fontSize: 12 }}
        >
          {summaryText}
        </Text>
      )}
    </>
  );
}
